import type { ReactNode } from 'react';

import { FaIcon } from './FaIcon';

export type TextWithIconProps = {
  icon?: string;
  text?: string;
  textCssClass?: string;
  children?: ReactNode;
  contentCssClass?: string;
  cssClass?: string;
  narrowMargin?: boolean;
};

export function TextWithIcon({
  icon,
  text,
  textCssClass,
  children,
  contentCssClass,
  cssClass,
  narrowMargin,
}: TextWithIconProps) {
  const effectiveMarginCssClass = narrowMargin ? 'me-1' : 'me-2';

  return (
    <span className={`text-with-icon ${cssClass ?? ''}`}>
      {icon != null && <FaIcon icon={`${icon} fa-fw`} cssClass={effectiveMarginCssClass} />}
      {text != null ? (
        <span className={textCssClass}>{text}</span>
      ) : children != null ? (
        <span className={contentCssClass}>{children}</span>
      ) : null}
    </span>
  );
}
